import { Suspense } from 'react'
import Login from '@/pages/login'
import { Outlet } from 'react-router-dom'
import CompactLayout from '@/layouts/compact'
import { GuestGuard } from '@/contexts/auth-context/guards/guest-guard'
import LoadingSection from '@/components/loading-indicator/loading-section'

export const publicRoutes = [
  {
    path: 'login',
    element: (
      <GuestGuard>
        <CompactLayout>
          <Suspense fallback={<LoadingSection loading />}>
            <Outlet />
          </Suspense>
        </CompactLayout>
      </GuestGuard>
    ),
    children: [
      {
        path: '',
        element: <Login />,
      },
    ],
  },
]
